import { useContext } from 'react';

import Context from '/druid/Context';
import createNativeUtterance from '/druid/createNativeUtterance';

export default function useSynthesize() {
  const { ponyfill, synthesize } = useContext(Context);

  return (utteranceOrText, progressFn) => {
    if (typeof utteranceOrText === 'string') {
      utteranceOrText = createNativeUtterance(ponyfill, { text: utteranceOrText });
    }

    return synthesize(ponyfill, utteranceOrText, { onStart: progressFn && (() => progressFn()) });
  };
}
